// src/components/layout/AppLayout.jsx
import React from "react";
import HeaderSidebar from "./sidebar";

const AppLayout = ({ children }) => {
  return (
    <>
      <HeaderSidebar />
      <div className="container mt-5 pt-4 main-content">
        {children}
      </div>
    </>
  );
};

export default AppLayout;
